/**
 * Foundation Formatting · Ore — formattazione italiana di monte-ore.
 *
 * STANDARD UFFICIALE Gruppo Impresa Suite:
 *   Ore:          "x,yy" (due decimali, virgola italiana). Esempi: "5,00", "7,50", "4,67".
 *   Ore signed:   "+x,yy" per valori positivi (0 e negativi restano non prefissati).
 *
 * Sono utility CORE riutilizzabili da tutti i Product Pack. Non contengono
 * semantica di dominio Presenze — sono solo formattatori numerici IT a due
 * decimali con virgola.
 */
import { formatDuration } from "@/foundation/duration/durationCore";
import { getActiveDurationFormat } from "@/foundation/duration/activeFormat";


// M-UX-05 · le durate seguono il formato dell'azienda di contesto (Foundation Durate).
export function fmtHours(n) {
  return formatDuration(n, getActiveDurationFormat());
}

export function fmtHoursSigned(n) {
  return formatDuration(n, getActiveDurationFormat(), { signed: true });
}
